import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/i18n.ts
const trackUsageGetInputSchema = z.object({ key: z.string().min(1) });
const trackUsageGetOutputSchema = z.object({ trackingEnabled: z.boolean() });
const buildInfoSchema = z.object({
	startTrackingTime: z.number().int().nonnegative(),
	buildTime: z.number().int().nonnegative()
});
const usageEntrySchema = z.object({
	ns: z.string().min(1).max(100),
	lang: z.string().min(1).max(20),
	key: z.string().min(1).max(500),
	usageCount: z.number().int().positive()
});
const trackUsagePostInputSchema = z.object({
	buildInfo: buildInfoSchema,
	usage: z.array(usageEntrySchema).max(5e3)
});
const i18nContract = oc.prefix("/i18n").tag("I18n").router({
	getTrackUsage: oc.route({
		method: "GET",
		path: "/track-usage",
		summary: "Check whether i18n usage tracking is enabled for the caller"
	}).input(trackUsageGetInputSchema).output(trackUsageGetOutputSchema),
	postTrackUsage: oc.route({
		method: "POST",
		path: "/track-usage",
		summary: "Report i18n key usage from the frontend",
		outputStructure: "detailed"
	}).input(trackUsagePostInputSchema).output(z.object({
		status: z.literal(201),
		body: z.void()
	}))
});
//#endregion
export { i18nContract };
